import queryParamUpdater from 'Map/utils/queryParamUpdater';
import sessionId from '../../configurer/sessionId';
import mainConfig from 'mainConfig';

const API_KEY_PARAM_NAME = 'key';
const SESSION_ID_PARAM_NAME = 'sessionId';
const TOMTOM_ORIGIN = 'api.tomtom.com';
class BaseUrlTransformer {
    constructor(key, testMethodImpl, transformMethodImpl) {
        this._testMethodImpl = testMethodImpl;
        this._transformMethodImpl = transformMethodImpl;
        this._key = key;
    }

    _isTomtomOrigin = () => {
        return mainConfig.origin === TOMTOM_ORIGIN;
    }

    test = (url) => {
        return this._testMethodImpl(url);
    };

    transform = (url) => {
        let modifiedUrl = queryParamUpdater(url, API_KEY_PARAM_NAME, this._key);

        if (this._isTomtomOrigin()) {
            modifiedUrl = queryParamUpdater(modifiedUrl, SESSION_ID_PARAM_NAME, sessionId.getInstance().get());
        }

        if (this._transformMethodImpl) {
            modifiedUrl = this._transformMethodImpl(modifiedUrl);
        }

        return modifiedUrl;
    }
}

export default (key, testMethodImpl, transformMethodImpl) => {
    return new BaseUrlTransformer(key, testMethodImpl, transformMethodImpl);
};



// WEBPACK FOOTER //
// ./map/tier/urlTransformers/baseUrlTransformer.js